import { render, staticRenderFns } from "./addDocumentConfig.vue?vue&type=template&id=d91471da&"
import script from "./addDocumentConfig.vue?vue&type=script&lang=js&"
export * from "./addDocumentConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports